const SESSION_ACCORDION_KEY = "red.accordionNavigation.open";

class ContentAccordionNavigation extends HTMLElement {
    connectedCallback() {
        this.accordionOpen = sessionStorage.getItem(SESSION_ACCORDION_KEY);
        if(this.accordionOpen) {
            this.openLatestAccordion();
            sessionStorage.removeItem(SESSION_ACCORDION_KEY);
        }
        this.accordionLink = this.querySelectorAll(".accordion-link");
        for (const link of this.accordionLink) {
            link.addEventListener('click', () => {
                this.saveLatestAccordion(link);
            });
        }
    }

    openLatestAccordion() {
        const accordion = this.querySelector(`[data-accordion="${this.accordionOpen}"]`);
        accordion.setAttribute("open", "");
    }

    saveLatestAccordion(link) {
        const accordion = link.closest("[data-accordion]").dataset["accordion"];
        sessionStorage.setItem(SESSION_ACCORDION_KEY, accordion);
    }
}

if (!customElements.get("content-accordion-navigation")) {
    customElements.define("content-accordion-navigation", ContentAccordionNavigation);
}
  